<template>
    <section id="booking_help" class="section_padding">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="section_heading_center">
                        <h2>{{ $t('Departure Flight') }}</h2>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('From') }} *</label>
                        <model-list-select :list="options" v-model="request.departure_from" :isDisabled="true"
                            :placeholder="$t('select2')" option-value="code" :custom-text="codeAndNameAndDesc">
                        </model-list-select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('To') }} *</label>
                        <model-list-select :list="options" v-model="request.departure_to" :placeholder="$t('select2')"
                            option-value="code" :custom-text="codeAndNameAndDesc" :isDisabled="true">
                        </model-list-select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('Flight date') }} *</label>
                        <VueDatePicker v-model="request.departure_date" :enable-time-picker="false" :disabled="true"
                            :placeholder="$t('select2')" />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('Flight degree') }} *</label>
                        <select v-model="request.departure_booking_degree" disabled class="form-control">
                            <option value="">{{ $t('select2') }}</option>
                            <option v-for="item in allowedDegree" :value="item">{{ $t(item) }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12 mt-4 mb-3">
                    <h4 class="primary-color bold">{{ $t('Favorite time to flight') }}</h4>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('First option') }} *</label>
                        <input class="form-control" v-model="request.prefered_departure_times[0]" disabled>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('Second option') }} *</label>
                        <input class="form-control" v-model="request.prefered_departure_times[1]" disabled>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('Third option') }} *</label>
                        <input class="form-control" v-model="request.prefered_departure_times[2]" disabled>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('Forth option') }} *</label>
                        <input class="form-control" v-model="request.prefered_departure_times[3]" disabled>
                    </div>
                </div>
            </div>
            <div class="row mt20">
                <div class="col-md-12 mt-3">
                    <div class="section_heading_center pull-left">
                        <h2>{{ $t('Return flight') }}</h2>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('From') }} *</label>
                        <model-list-select :list="options" v-model="request.return_from_airport"
                            :placeholder="$t('select2')" option-value="code" :custom-text="codeAndNameAndDesc"
                            :isDisabled="true">
                        </model-list-select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('To') }} *</label>
                        <model-list-select :list="options" v-model="request.return_to_airport"
                            :placeholder="$t('select2')" option-value="code" :isDisabled="true"
                            :custom-text="codeAndNameAndDesc">
                        </model-list-select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('Flight date') }} *</label>
                        <VueDatePicker v-model="request.return_date" :enable-time-picker="false" :disabled="true"
                            :placeholder="$t('select2')" />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('Flight degree') }} *</label>
                        <select v-model="request.return_booking_degree" class="form-control" disabled>
                            <option value="">{{ $t('select2') }}</option>
                            <option v-for=" item in allowedDegree " :value="item">{{ $t(item) }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12 mt-4 mb-3">
                    <h4 class="primary-color bold">{{ $t('Favorite time to flight') }}</h4>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('First option') }} *</label>
                        <input class="form-control" v-model="request.prefered_return_times[0]" disabled>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('Second option') }} *</label>
                        <input class="form-control" v-model="request.prefered_return_times[1]" disabled>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('Third option') }} *</label>
                        <input class="form-control" v-model="request.prefered_return_times[2]" disabled>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="primary-color bold">{{ $t('Forth option') }} *</label>
                        <input class="form-control" v-model="request.prefered_return_times[3]" disabled>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import jsonData from '@/assets/file/airports-v2.json';
import { ModelListSelect } from 'vue-search-select';
import "vue-search-select/dist/VueSearchSelect.css";
export default {
    name: 'BookingHelpDetails',
    components: { ModelListSelect },
    data: () => ({
        options: [],
        request: {
            departure_from: '',
            departure_to: 'RUH',
            departure_date: null,
            departure_booking_degree: '',
            return_from: 'RUH',
            return_to: '',
            return_date: null,
            return_booking_degree: '',
            prefered_departure_times: [],
            prefered_return_times: [],
            guest_id: null
        },
        allowedDegree: [],
        times: [],
    }),
    methods: {
        codeAndNameAndDesc(item) {
            return `${item[this.$i18n.locale + '_name']} ( ${item.code} ) - ${item[this.$i18n.locale + '_country']} / ${item[this.$i18n.locale + '_city']}`
        },
    },
    mounted() {
        this.options = jsonData;
        const allowedDegreeString = localStorage.getItem('allowed_degree');
        const guest_data = JSON.parse(localStorage.getItem('guest_data'));

        this.allowedDegree = JSON.parse(allowedDegreeString);
        var need_flight_helping = guest_data.guest.guest_need_help_flight[0];

        this.request = {
            departure_from: need_flight_helping.departure_from,
            departure_to: need_flight_helping.departure_to,
            departure_date: need_flight_helping.departure_date,
            departure_booking_degree: need_flight_helping.departure_booking_degree,
            return_from_airport: need_flight_helping.return_from,
            return_to_airport: need_flight_helping.return_to,
            return_date: need_flight_helping.return_date,
            return_booking_degree: need_flight_helping.return_booking_degree,
            prefered_departure_times: JSON.parse(need_flight_helping.prefered_departure_times),
            prefered_return_times: JSON.parse(need_flight_helping.prefered_return_times),
        };
    }
}
</script>
<style lang="scss" scoped>
.section_padding {
    padding: 50px 0;
}
label{
    font-size: 14px;
    margin-bottom: 8px;
}
.form-group{
    margin-bottom: 1rem;
}
</style>